import React, { useEffect } from 'react';
import { useStore } from '../../store/Store';
import {
  fetchData,
  updatePrograma,
  addArea
} from '../../store/ActionProgramas';
import PageLoading from '../../components/PageLoading';
import PageError from '../../components/PageError';
import { switchAdminMenu, selectPrograma } from '../../store/ActionAdmin';
import { areas, programasConst } from '../../utils/constantes';

export const AdminProgramas = () => {
  const {
    state: { programas, loading },
    dispatch
  } = useStore();

  useEffect(() => {
    programas.length === 0 && fetchData(dispatch);
  }, []);

  const handleClick = programa => {
    switchAdminMenu(dispatch, 'editPrograma');
    selectPrograma(dispatch, programa);
  };

  const handleCreate = () => {
    programasConst.forEach(prog => {
      switchAdminMenu(dispatch, 'editPrograma');
    });
  };

  const handleAreas = () => {
    areas.forEach(area => {
      addArea(dispatch, area);
    });
  };

  const fillContent = () => {
    if (loading) return <PageLoading />;
    if (!programas)
      return <PageError error="No se pudieron obtener los programas." />;

    let key = 1;
    return (
      <section id="Admin__section">
        <h2>Listado de programas</h2>
        <button onClick={() => handleCreate()} className="btn btn-secondary">
          Crear
        </button>
        <button onClick={() => handleAreas()} className="btn" disabled={true}>
          Areas
        </button>
        <div className="Admin__listado">
          {programas.map(programa => (
            <div
              className="Admin__itemListado"
              key={key++}
              onClick={() => handleClick(programa)}
            >
              {programa.pregrado}
            </div>
          ))}
        </div>
      </section>
    );
  };

  return fillContent();
};
